export function parseContentDispositionFilename(headerValue, fallback) {
  if (!headerValue) return fallback;

  const extMatch = headerValue.match(/filename\*\s*=\s*[^']*'[^']*'([^;]+)/i);
  if (extMatch) {
    try {
      return decodeURIComponent(extMatch[1].trim());
    } catch {
      // fall through to filename=
    }
  }

  const match = headerValue.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (match) return match[1].trim();

  return fallback;
}
